import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./i18n";
import { MaintenanceAwareRoot } from "./components/common/MaintenanceAwareRoot";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <MaintenanceAwareRoot />
  </StrictMode>,
);
